import { type TFormField } from '@nirmata/shared';
import {
  AlignLeft,
  Box,
  CheckSquare,
  CircleDot,
  Columns,
  Hash,
  ListChecks,
  Type,
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export interface FieldConfig {
  type: string;
  label: string;
  icon: LucideIcon;
  defaultProps: Partial<TFormField>;
  validations: string[];
}

export interface FieldsConfig {
  [groupName: string]: FieldConfig[];
}

export const FORM_FIELDS_CONFIG: FieldsConfig = {
  'Layout Components': [
    {
      type: 'container',
      label: 'Container',
      icon: Box,
      defaultProps: {
        componentType: 'container',
        fieldMetadata: {
          isInput: false,
          isContainer: true,
        },
        childFields: [],
      },
      validations: [],
    },
    {
      type: 'section',
      label: 'Section',
      icon: Columns,
      defaultProps: {
        componentType: 'section',
        componentProps: {
          variant: 'ghost',
          layout: 'row',
        },
        fieldMetadata: {
          isInput: false,
          isContainer: true,
        },
        childFields: [
          {
            fieldId: 'container-1',
            fieldName: 'container-1',
            componentType: 'container',
            fieldMetadata: {
              isInput: false,
              isContainer: true,
            },
            childFields: [],
          },
          {
            fieldId: 'container-2',
            fieldName: 'container-2',
            componentType: 'container',
            fieldMetadata: {
              isInput: false,
              isContainer: true,
            },
            childFields: [],
          },
        ],
      },
      validations: [],
    },
  ],
  'Basic Fields': [
    {
      type: 'text',
      label: 'Text Field',
      icon: Type,
      defaultProps: {
        componentType: 'text-field',
        fieldMetadata: {
          isInput: true,
        },
      },
      validations: ['required', 'minLength', 'maxLength', 'pattern'],
    },
    {
      type: 'number',
      label: 'Number Field',
      icon: Hash,
      defaultProps: {
        componentType: 'number-field',
        fieldMetadata: {
          isInput: true,
        },
      },
      validations: ['required', 'min', 'max'],
    },
    {
      type: 'textarea',
      label: 'Text Area',
      icon: AlignLeft,
      defaultProps: {
        componentType: 'textarea-field',
        fieldMetadata: {
          isInput: true,
        },
      },
      validations: ['required', 'minLength', 'maxLength', 'pattern'],
    },
    {
      type: 'checkbox',
      label: 'Checkbox',
      icon: CheckSquare,
      defaultProps: {
        componentType: 'checkbox-field',
        fieldMetadata: {
          isInput: true,
        },
      },
      validations: ['required'],
    },
  ],
  'Choice Fields': [
    {
      type: 'select',
      label: 'Select Field',
      icon: ListChecks,
      defaultProps: {
        componentType: 'select-field',
        fieldMetadata: {
          isInput: true,
        },
        componentProps: {
          options: [],
        },
      },
      validations: ['required'],
    },
    {
      type: 'radio',
      label: 'Radio Group',
      icon: CircleDot,
      defaultProps: {
        componentType: 'radio-field',
        fieldMetadata: {
          isInput: true,
        },
        componentProps: {
          options: [],
        },
      },
      validations: ['required'],
    },
  ],
};
